import React from 'react';

import './BackgroundShapes.css';

interface BackgroundShapesProps {}

const BackgroundShapes: React.FC<BackgroundShapesProps> = () => {
  return (
    <div className="background-shapes">
      <div className="background-shapes__shape background-shapes__shape--left"></div>
      <div className="background-shapes__shape background-shapes__shape--right"></div>
    </div>
  );
};

export default BackgroundShapes;
